import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SentenceCase } from './sentence-case.component';


@NgModule({
  declarations: [
    SentenceCase
  ],
  imports: [
    CommonModule,
  ],
  exports:[SentenceCase]
})
export class FaPipesModule { }


